import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";

export default function AlertDialog({
  showInitialWarningDialog,
  setShowInitialWarningDialog,
  submitHandler,
}) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (showInitialWarningDialog === true) {
      setOpen(showInitialWarningDialog);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    setShowInitialWarningDialog(false);
  };

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
      
      </Button> */}
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "700" }}>
          Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Once the Test is opened, if you try to change the tabs your test
            will be automatically submitted
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={submitHandler} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}